enum MessageType {
  Default = 0,
  UserJoin = 7,
  Reply = 19
}

export default MessageType



// WEBPACK FOOTER //
// ./src/types/messagetype.ts